import classNames from "classnames";

import Block from "components/Layout/Block";

import styles from "./Input.module.scss";
import React from "react";

type InputProps = {
  label: string;
  name: string;
  type?: string;
  placeholder?: string;
  required?: boolean;
  widthCharacters?: string;
  disabled?: boolean;
  hidden?: boolean;
  register?: any;
  error?: any;
  maxLength?: string;
  defaultValue?: string;
  value?: string;
  autoFocus?: boolean;
  caption?: string;
};

const Input = ({
  name,
  type = "text",
  placeholder,
  label,
  widthCharacters,
  disabled,
  register,
  hidden,
  defaultValue,
  error,
  caption,
  ...rest
}: InputProps) => {
  const inputClass = classNames({
    [styles.input]: true,
    [styles[`input-error`]]: error
  });

  // Add custom width if set (+3 = padding)
  const customWidth = widthCharacters ? parseInt(String(widthCharacters), 10) + 3 : "";

  return (
    <div className={styles.inputWrap} style={hidden ? { display: "none" } : {}}>
      {label && (
        <label htmlFor={name} className={styles.label}>
          <span className="body-text">{label}</span>
        </label>
      )}
      {/*@ts-ignore*/}
      <input
        type={type}
        placeholder={placeholder}
        defaultValue={defaultValue}
        name={name}
        id={name}
        disabled={disabled}
        ref={register}
        className={inputClass}
        style={customWidth ? { width: `${customWidth}ch` } : {}}
        {...rest}
      />
      {error?.message && (
        <Block top={2}>
          <div className="body-text color--red">↑ {error.message}</div>
        </Block>
      )}
      {caption && (
        <Block top={2}>
          {caption?.split("\n").map((line, index) => (
            <p key={index} className="text-caption">
              {line}
            </p>
          ))}
        </Block>
      )}
    </div>
  );
};

export default Input;
